import React from 'react';
import { Image, Box } from '@chakra-ui/react';
import appConfig from '../Config/appConfig'

/**
 * ImageComponent - Renders an image with styles based on the provided variant and image metadata.
 *
 * @param {Object} image - The image object with URL, altText, title, and decorative properties.
 * @param {string} variant - The variant name for styling (e.g., xs, sm, md, lg, rounded-md).
 * @param {number} rotation - Rotation angle in degrees (optional).
 */

const ImageComponent = ({ image = {}, variant, rotation = 0, marginTop, marginBottom, position }) => {
  const {
    url = '/default.png',
    altText = 'Image',
    title = null,
    decorative = false,
  } = image;

  return (
    <Box
      as="figure"
      width={`var(--image-${variant}-width, auto)`}
      height={`var(--image-${variant}-height, auto)`}
      borderRadius={`var(--image-${variant}-border-radius, 0)`}
      overflow="hidden"
      role={!decorative ? 'img' : undefined}
      transform={`rotate(${rotation}deg)`}
      transition="transform 0.3s ease-in-out"
      display="flex"
      justifyContent="flex-start"
      alignItems="flex-start"
      mb={marginBottom || 4}
      mt={marginTop || 4}
    >
      <Image
        src={`${appConfig.ImageBlobBaseUrl}/${url}`}
        alt={decorative ? '' : altText}
        title={title || altText}
        objectFit="contain"
        objectPosition={position || 'center'}
        boxSize="100%"
        aria-hidden={decorative}
        focusable={!decorative}
        loading="lazy"
      />
    </Box>
  );
};

export default ImageComponent;
